<script>
  import {Component, Vue} from "vue-property-decorator";
  import printContent from "@/pages/components/Print/modules/M60-print/print-content";
  import printFooter from "@/pages/components/Print/modules/M60-print/print-footer";
  import printHead from "@/pages/components/Print/modules/M60-print/print-head";
  import gridTable from "@/pages/components/Print/modules/M60-print/common/grid-table";
  import _ from 'lodash'

  @Component({
    components: {
      printContent,
      printFooter,
      printHead,
      gridTable
    }
  })

  export default class M60_Print extends Vue {
    info = {
      baseDataList: []
    }
    chunkArr = []

    handlePrintSixty() { // POST_MRP_PO_PRINT_SIXTY
      const printDate = this.$utils.formatTime(new Date())
      this.$apis.autoAPi.POST_MRP_PO_PRINT_SIXTY({
        "scmPoNumber": this.$route.query.scmPoNumber || ''
      }).done(res => {
        const data = res.data
        let baseDataList = [
          {
            vendorCode: data.vendorCode,
            sapPoNo: data.sapPoNo,
            poTypeDesc: data.poTypeDesc,
            poArea: data.poArea
          }, {
            // 固定文字
            style: {
              background: 'rgba(255,255,128,.5) !important',
            },
            vendorCode: 'PAYMENT',
            sapPoNo: 'DELIVERY TERMS',
            fixedText: 'TRANSPORT MODE',
            poTypeDesc: 'IMPORTER',
            poArea: 'IMPORTER DESCRIPTION'
          }, {
            vendorCode: data.paymentTermDesc,
          }
        ]
        /*let arr = [...Array(6)].map((item, index) => {
          return {
            ...data.poItems[0],
            materialCode: 'test' + index
          }
        })*/
        // 分组条件 当前款号+颜色信息
        let groupList = data.poItems.reduce((pre, cur, index) => {
          let key = ''
          let summaryMap = _.groupBy(cur.poScheduleLineSummaries, gItem => gItem.colorCode)
          _.forIn(summaryMap, (list, colorCode) => {
            key = cur.materialCode + colorCode
            if (!(key in pre)) {
              pre[key] = [{
                ...cur,
                poScheduleLineSummaries: list
              }]
            }
          })

          // cur.poScheduleLineSummaries.forEach(item => {
          //   key = cur.materialCode + item.colorCode
          //   if (!(key in pre)) {
          //     pre[key] = [{
          //       ...cur,
          //       // poScheduleLineSummaries:[item]
          //     }]
          //   }
          // })
          return pre
        }, {})
        // chunkArr -> [[],[]]
        this.chunkArr = Chunk(Object.values(groupList), 3)
        this.info = data
        this.info.baseDataList = baseDataList
        this.info.printDate = printDate

        function Chunk(arr = [], size = 1) {
          return arr.length ? arr.reduce((t, v) => (t[t.length - 1].length === size ? t.push([v]) : t[t.length - 1].push(v), t), [[]]) : [];
        }
      })
        .fail(err => {
        })
    }

    mounted() {
      this.handlePrintSixty()
    }

    render(h) {
      const {chunkArr, info} = this
      const currentPageData = function (item) {
        /*
        poScheduleLineSummaries
        allTotalPrice  总合计价
        allTotalQTY 总合计数量*/
        let [poScheduleLineSummaries, allTotalPrice, allTotalQTY] = [[], 0, 0]
        // otherInfo -> [[],[]] 表格2 3 数据
        let otherInfo = item.map(inner => {
          const quantitySizeCode = [{
            sizeCode: 'Size',
            quantity: 'Qty',
            totalQuantity: 'Total'
          }]
          /*
          totalPrice  合计价
          totalQTY  合计数量
          price 单价
          currency 币种
         */
          let [materialInfo, totalPrice, totalQTY, price, currency] = ['', 0, 0, 0, '']
          let otherDataList = inner.map(item => {
            poScheduleLineSummaries = item.poScheduleLineSummaries.map((_item, index, arr) => {
              price = arr[0].price
              materialInfo = item.materialCode + item.materialDesc
              quantitySizeCode.push({
                sizeCode: _item.sizeCode || '',
                quantity: _item.quantity || '',
                totalQuantity: _item.quantity || '',
              })
              totalQTY += _item.quantity
              item.colorCode = _item.colorCode
              item.currency = _item.currency
              item.price = _item.price
              item.currency = _item.currency
            })
            totalPrice = totalQTY * price || 0
            allTotalPrice += totalPrice
            allTotalQTY += totalQTY
            quantitySizeCode.push({
              sizeCode: 'Total',
              quantity: (totalQTY || 0).toFixed(0),
              totalQuantity: (totalQTY || 0).toFixed(0),
            }, {
              sizeCode: 'Price',
              quantity: (totalPrice || 0).toFixed(2),
              totalQuantity: (totalPrice || 0).toFixed(2),
            })
            console.log(info, 'infoinfoinfo')
            return {
              ...item,
              style: {
                background: 'rgba(255,255,128,.5) !important',
              }
            }
          })
          // 定义表格 行
          const renderCell = {
            render: function (h) {
              const gridStyle = {
                display: 'grid',
                'grid-template-columns': `86px repeat(${quantitySizeCode.length},1fr)`,
                gridColumnGap: '0',
                gridRowGap: '0',
                borderTop: '1px solid'
              }
              const commonStyle = {
                'font-size': '12px',
                ' word-break': 'break-word',
                'text-align': 'center',
              }
              return <div style={gridStyle}>
                <div style={{
                  gridColumnEnd: `span 1`,
                  gridRowEnd: `span 2`,
                  borderRight: '1px solid',
                  wordBreak: 'break-all',
                  ...commonStyle
                }}>{materialInfo}</div>
                {
                  quantitySizeCode.map((item,index,sources) =>
                    <div>
                      <div style={{
                        borderRight: '1px solid',
                        borderBottom: '1px solid',
                        background: ['Size','Total','Price'].includes(item.sizeCode)&&'rgba(255,255,128,.5) !important',
                        ...commonStyle
                      }}>{item.sizeCode}</div>
                      <div style={{borderRight: '1px solid',
                        borderBottom: '1px solid',
                        background: index === 0 &&'rgba(255,255,128,.5) !important',
                        ...commonStyle}}
                      >
                        {item.quantity}</div>
                      <div style={{
                        borderRight: '1px solid',
                        background: 'rgba(128,192,128, .8) !important',
                        ...commonStyle}}
                      >
                        {item.totalQuantity}</div>
                    </div>
                  )
                }
              </div>
            }
          }
          otherDataList.push(renderCell)
          // 表格total数据
          const totalDataList = [
            {
              "label": "FINAL TOTAL",
              "property": "",
            }, {
              "label": (allTotalQTY || 0).toFixed(0),
              "property": "",
            }, {
              "label": (allTotalPrice || 0).toFixed(2),
              "property": "",
            },]
          return {
            otherDataList: otherDataList,
            totalDataList: totalDataList
          }
        })
        return otherInfo
      }
      return (
        <div>
          {chunkArr.map((inner, index) =>
            <div class="print-box">
              <printHead info={info}></printHead>
              <printContent otherInfo={currentPageData(inner)} info={info}></printContent>
              {<printFooter
                info={info}
                {...{
                  props: {
                    currentPage: index + 1,
                    totalPage: chunkArr.length
                  }
                }}
              ></printFooter>}
            </div>)
          }
        </div>

      );
    }
  }
</script>
<style scoped>
  /*@page { size: portrait }*/
  @media print {
    .print-box {
      page-break-inside: avoid !important;
    page-break-before: unset !important;
      padding: 14px 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }

  .print-box {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    padding: 14px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    /*padding-bottom: 0;*/
  }
</style>
